// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__3eAbG","form":"styles_form__1q8RT","modal-button":"styles_modal-button__KhX1k"};